import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import asyncComponent from "util/asyncComponent";
import { Component } from "react";

const PrivateRoute = ({ userInfo, component: Component, ...rest }) => {
  // const user_role = userInfo? userInfo:null;
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "admin" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const VerifyRoute = ({ userInfo, component: Component, ...rest }) => {
  // const user_role = userInfo? userInfo:null;
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "verify_scheduler" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const OrionRoute = ({ userInfo, component: Component, ...rest }) => {
  // const user_role = userInfo? userInfo:null;
  const role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) => {
        let data = { ...props, role };
        return role !== "finance_user" &&
          role !== "accounts_user" &&
          role !== "project_manager" &&
          role !== "coordinator" &&
          role !== "data_entry" &&
          role !== "client_user" &&
          role !== "client_manager" &&
          role !== "client_admin" ? (
          <Component {...data} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

const FinanceRoute = ({ userInfo, component: Component, ...rest }) => {
  // const user_role = userInfo? userInfo:null;
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "finance_user" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
const CommonRateCardRoute = ({ userInfo, component: Component, ...rest }) => {
  // const user_role = userInfo? userInfo:null;
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "client_user" ||
        user_role === "client_manager" ||
        user_role === "client_admin" ||
        user_role === "partner" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const PMTRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "project_manager" ||
        user_role === "coordinator" ||
        user_role === "kci" ||
        user_role === "admin" ||
        user_role === "auditor_user" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
const PMTRouteAdmin = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "project_manager" ||
        user_role === "admin" ||
        user_role === "kci" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
const PMTDataEntry = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "project_manager" ||
        user_role === "coordinator" ||
        user_role === "data_entry" ||
        user_role === "admin" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
const PMTClientDashboard = ({ userInfo, component: Component, ...rest }) => {
  // console.log("PMTClientDashboard.....................!")
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "client_user" ||
        user_role === "client_manager" ||
        user_role === "client_admin" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const AccountsRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "finance_user" || user_role === "accounts_user" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
const ClientInvoiceRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "client_invoicer" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const QcRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "qc" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const CustomerConnectRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "customer_connect" ||
        user_role === "project_manager" ||
        user_role === "coordinator" ||
        user_role === "admin" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const KCIRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "kci" ||
        user_role === "coordinator" ||
        user_role === "admin" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const PayablePartnerRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "payable_partner_user" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const CoordinatorRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "coordinator" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const AllExceptExternalAgentRoute = ({
  userInfo,
  component: Component,
  ...rest
}) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role !== "agent" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const VendorRoute = ({ userInfo, component: Component, location, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  const urlParts = location.pathname.split("/");
  const rateId = urlParts[2];

  if (!user_role && rateId) {
    localStorage.setItem("rateId", rateId);
  } else if (user_role && rateId) {
    localStorage.removeItem("rateId");
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "project_manager" ||
        user_role === "coordinator" ||
        user_role === "admin" ||
        user_role === "internal_agent" ||
        user_role === "partner" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/portals",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
// /partner-plans
const VendorPlanRoute = ({
  userInfo,
  component: Component,
  location,
  ...rest
}) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  const path = location.pathname;

  if (!user_role && path === "/partner-plans") {
    localStorage.setItem("partnerPlans", true);
  } else if (user_role && path === "/partner-plans") {
    localStorage.removeItem("partnerPlans");
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "project_manager" ||
        user_role === "coordinator" ||
        user_role === "admin" ||
        user_role === "internal_agent" ||
        user_role === "partner" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/portals",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const EngineerRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "partner" || user_role === "partner_employee" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const PMRoute = ({ userInfo, component: Component, ...rest }) => {
  const user_role = localStorage.getItem("user_role")
    ? localStorage.getItem("user_role")
    : null;
  return (
    <Route
      {...rest}
      render={(props) =>
        user_role === "project_manager" ||
        user_role === "coordinator" ||
        user_role === "kci" ||
        user_role === "admin" ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/not-found",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser };
};

const App = (props) => {
  return (
    <>
      <div className="gx-main-content-wrapper">
        <Switch>
          <OrionRoute
            path={`${props.match.url}registration`}
            component={asyncComponent(() => import("./Registration"))}
          />
          <OrionRoute
            path={`${props.match.url}jobs`}
            component={asyncComponent(() => import("./Dashboard/DefineJob"))}
          />
          <OrionRoute
            path={`${props.match.url}jobs-filter`}
            component={asyncComponent(() => import("./Dashboard/FilterJob"))}
          />
          <OrionRoute
            path={`${props.match.url}sendmail`}
            component={asyncComponent(() => import("./Dashboard/SendMail"))}
          />
          <OrionRoute
            path={`${props.match.url}sendmail-flow`}
            component={asyncComponent(() => import("./Dashboard/SendMailFlow"))}
          />
          <OrionRoute
            path={`${props.match.url}vcomms`}
            component={asyncComponent(() => import("./Dashboard/Vcomms"))}
          />
          <OrionRoute
            path={`${props.match.url}records`}
            component={asyncComponent(() => import("./Dashboard"))}
          />
          <OrionRoute
            path={`${props.match.url}detail/:uuid`}
            component={asyncComponent(() => import("./Dashboard/CardTab"))}
          />
          <OrionRoute
            path={`${props.match.url}redo`}
            component={asyncComponent(() => import("./Dashboard/Redo"))}
          />
          <OrionRoute
            path={`${props.match.url}skill`}
            component={asyncComponent(() => import("./Dashboard/Skill"))}
          />
          <OrionRoute
            path={`${props.match.url}metadata`}
            component={asyncComponent(() => import("./Dashboard/Metadata"))}
          />
          <OrionRoute
            path={`${props.match.url}rejected`}
            component={asyncComponent(() => import("./RejectedRecords"))}
          />
          <OrionRoute
            path={`${props.match.url}qc/rejected`}
            component={asyncComponent(() => import("./QcRejectedEntries"))}
          />
          <OrionRoute
            path={`${props.match.url}partner-tickets`}
            component={asyncComponent(() =>
              import(
                "../routes/ProjectManagementTool/Tickets/PartnerTicketList"
              )
            )}
          />
          <OrionRoute
            path={`${props.match.url}client-payables`}
            component={asyncComponent(() =>
              import("../routes/ClientLogin/ClientPayablesListing")
            )}
          />
          <OrionRoute
            path={`${props.match.url}vendor-tasks`}
            component={asyncComponent(() =>
              import("./VendorManagementTasks/TaskTabs")
            )}
          />
          <OrionRoute
            path={`${props.match.url}coverage`}
            component={asyncComponent(() => import("./Coverages/Coverages"))}
          />
          <AccountsRoute
            exact
            path={`${props.match.url}finance`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/PartnerKYC"))}
          />
          <AccountsRoute
            path={`${props.match.url}kyc-verify/:id`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/KYCVerify"))}
          />
          <AccountsRoute
            path={`${props.match.url}partner-invoice`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/PartnerInvoice"))}
          />
          <AccountsRoute
            path={`${props.match.url}client-purchase-order`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/ClientPurchaseOrder")
            )}
          />
          <FinanceRoute
            path={`${props.match.url}add-client-costcentre`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/AddClientAndCostCentre")
            )}
          />
          <AccountsRoute
            path={`${props.match.url}client-invoice`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/AddnewClient"))}
          />
          <FinanceRoute
            path={`${props.match.url}partner-invoice-review`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/PartnerInvoiceReview")
            )}
          />
          <AccountsRoute
            path={`${props.match.url}finance-export-import`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/ExportImportReports")
            )}
          />
          <FinanceRoute
            path={`${props.match.url}finance-dashboard`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/FinanceDashboard")
            )}
          />
          <FinanceRoute
            path={`${props.match.url}client-invoice-review`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/ClientInvoiceReview")
            )}
          />
          <FinanceRoute
            path={`${props.match.url}payables`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/Payables"))}
          />
          <FinanceRoute
            path={`${props.match.url}invoice-request`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/InvoiceRequest/InvoiceRequest")
            )}
          />
          <AccountsRoute
            path={`${props.match.url}tpp-transactions`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/TPPTransactions")
            )}
          />
          <AccountsRoute
            path={`${props.match.url}actions`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/Tasks"))}
          />
          <AccountsRoute
            path={`${props.match.url}paid-invoices`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/Payables/PaidInvoiceList")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}whatsapp-msg`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/WhatsAppTwilo/WhatsAppMsg")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}project`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Project/Projects")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}project-list`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Project/ProjectListing")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}project-details/:id`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Project/ProjectDetails")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}takeout`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Takeout/TakeoutList")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}asset-management`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Assets/AssetManagement")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}kit-management`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Assets/KitManagement")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}asset-home`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Assets/AssetHomePage")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}template-edit/:id`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Project/ProjectCreateEdit")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}manager-dashboard`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/PMTDashboard/DashboardManager")
            )}
          />
          <PMTRoute
            path={`${props.match.url}coordinator-dashboard`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/PMTDashboard/CoordinatorDashboard"
              )
            )}
          />
          <PMTRoute
            path={`${props.match.url}project-expense`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Project/ProjectExpense")
            )}
          />
          <PMTRoute
            path={`${props.match.url}create-ticket`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tickets/CreateTicket")
            )}
          />
          <PMTRoute
            path={`${props.match.url}create-techlocal-ticket`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/TechlocalTicket/TicketCreationListing"
              )
            )}
          />
          <PMTRoute
            path={`${props.match.url}ticket-details/:uuid`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tickets/TicketDetails")
            )}
          />
          <PMTRoute
            path={`${props.match.url}ticket-list`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tickets/TicketList")
            )}
          />
          <PMTRoute
            path={`${props.match.url}auto-allocate`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/AutoAllocate/AddPartnerPincode")
            )}
          />
          <KCIRoute
            path={`${props.match.url}kci-tasks`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tasks/Tasks")
            )}
          />
          <PMTDataEntry
            path={`${props.match.url}tasks`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tasks/Tasks")
            )}
          />
          <PMTRoute
            path={`${props.match.url}partner-invoices`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Finance/PartnerInvoice"))}
          />
          {/* <PMTRoute path={`${props.match.url}adhoc-ticket-details/:uuid`} component={asyncComponent(() => import('./ProjectManagementTool/Tickets/AdhocTicketDetails'))} /> */}
          <PMTRoute
            path={`${props.match.url}adhoc-ticket-details/:uuid`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tickets/TicketDetails")
            )}
          />
          <PMTRoute
            path={`${props.match.url}project-reports`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Project/Reports")
            )}
          />
          <PMTRoute
            path={`${props.match.url}escalate`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/Tickets/TicketEscalation/GeneralEscalation"
              )
            )}
          />
          <PMTRoute
            path={`${props.match.url}sla`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/SLA/SLAHomePage")
            )}
          />
          <PMTRoute
            path={`${props.match.url}escalate_dashboard`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/Tickets/TicketEscalation/EscalationDashboard"
              )
            )}
          />
          <PMTClientDashboard
            path={`${props.match.url}client-dashboard`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/PMTDashboard/DashboardClient")
            )}
          />
          <PMTClientDashboard
            path={`${props.match.url}ticket-progress`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/PMTDashboard/Progress")
            )}
          />
          <PMTClientDashboard
            path={`${props.match.url}client-project-list`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/PMTDashboard/ProjectList")
            )}
          />
          <PMTClientDashboard
            path={`${props.match.url}client-takeout`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Takeout/TakeoutList")
            )}
          />
          <QcRoute
            path={`${props.match.url}qc-ticket-list`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/QCDashboard/QcTicketList")
            )}
          />
          <QcRoute
            path={`${props.match.url}qc-tasks`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tasks/Tasks")
            )}
          />
          <PMTRoute
            path={`${props.match.url}tools`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Tools/Tools"))}
          />
          <CustomerConnectRoute
            path={`${props.match.url}raw-address`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/RawAddress/RawAddress")
            )}
          />
          <PMTRoute
            path={`${props.match.url}customerfile-ticketlisting`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tickets/CustomerFileTicketList")
            )}
          />
          <PMTRoute
            path={`${props.match.url}audit-documents`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/AuditDocuments/AuditDocumentList")
            )}
          />
          <PMTRoute
            path={`${props.match.url}notification-dashboard`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/NotificationDashboard/NotificationListing"
              )
            )}
          />
          <VerifyRoute
            path={`${props.match.url}verify-schedule`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Tasks/CheckScheduleTableAll")
            )}
          />
          <PMTRoute
            path={`${props.match.url}asset-details/:uuid/:asset_id/`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Assets/AssetDetails")
            )}
          />
          <PMTRoute
            path={`${props.match.url}test-graph`}
            component={asyncComponent(() => import("./Graph/ActivityGraph"))}
          />
          <CoordinatorRoute
            path={`${props.match.url}coordinator-project-list`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/Project/ProjectListingCoordinator"
              )
            )}
          />
          <PMTRoute
            path={`${props.match.url}spare-management`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/Spares/SpareManagement")
            )}
          />
          <PMTRoute
            path={`${props.match.url}chat`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/PartnerChat/PartnerChat")
            )}
          />
          <ClientInvoiceRoute
            exact
            path={`${props.match.url}client-invoices`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/ClientInvoicingMarking/ClientInvoiceListing")
            )}
          />
          <PMTRoute
            path={`${props.match.url}to-do`}
            component={asyncComponent(() => import("./ToDoTasks/ToDoTasks"))}
          />
          {/* <PMTRoute path={`${props.match.url}adhoc-ticket`} component={asyncComponent(() => import('./ProjectManagementTool/Project/AdhocTicket'))}/> */}
          {/* <Route
        <Route path={`${props.match.url}registration`} component={asyncComponent(() => import('./Registration'))}/>
        <Route path={`${props.match.url}jobs`} component={asyncComponent(() => import('./Dashboard/DefineJob'))}/>
        <Route path={`${props.match.url}jobs-filter`} component={asyncComponent(() => import('./Dashboard/FilterJob'))}/>
        <Route path={`${props.match.url}sendmail`} component={asyncComponent(() => import('./Dashboard/SendMail'))}/>
        <Route path={`${props.match.url}sendmail-flow`} component={asyncComponent(() => import('./Dashboard/SendMailFlow'))}/>
        <Route path={`${props.match.url}vcomms`} component={asyncComponent(() => import('./Dashboard/Vcomms'))}/>
        <Route path={`${props.match.url}records`} component={asyncComponent(() => import('./Dashboard'))}/>
        <Route path={`${props.match.url}detail/:uuid`} component={asyncComponent(() => import('./Dashboard/CardTab'))}/>
        <Route path={`${props.match.url}redo`} component={asyncComponent(() => import('./Dashboard/Redo'))}/>
        <Route path={`${props.match.url}skill`} component={asyncComponent(() => import('./Dashboard/Skill'))}/>
        <Route path={`${props.match.url}metadata`} component={asyncComponent(() => import('./Dashboard/Metadata'))}/>
        <Route path={`${props.match.url}rejected`} component={asyncComponent(() => import('./RejectedRecords'))}/>
        <Route path={`${props.match.url}qc/rejected`} component={asyncComponent(() => import('./QcRejectedEntries'))}/>
        {/* <Route
            path={`${match.url}dashboard-data`}
            component={asyncComponent(() => import('./Dash'))}
            render={() => (
              (user_role!== 'qa' && user_role!== 'partner' && user_role!== 'agent')? (
                <Redirect to="/dashboard-data"/>
              ) : (
                <Redirect to="/records"/>
              )
            )}
        /> */}
          <PrivateRoute
            path={`${props.match.url}dashboard`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Dash"))}
          />
          <PMTRouteAdmin
            path={`${props.match.url}report-automation`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/PMTDashboard/ReportAutomation")
            )}
          />
          <OrionRoute
            path={`${props.match.url}audit-trail`}
            component={asyncComponent(() => import("./Dashboard/AuditTrail"))}
          />
          <PrivateRoute
            path={`${props.match.url}audit-trail-details/:id`}
            component={asyncComponent(() =>
              import("./Dashboard/AuditTrailDetails")
            )}
          />
          <CommonRateCardRoute
            path={`${props.match.url}rate-card`}
            component={asyncComponent(() => import("./RateCard/RateCard"))}
          />
          <Route
            path={`${props.match.url}not-authorized`}
            component={asyncComponent(() => import("./errorPages/401"))}
          />
          <Route
            path={`${props.match.url}not-found`}
            component={asyncComponent(() => import("./errorPages/404"))}
          />
          {/* <PrivateRoute path={`${props.match.url}admin-project-listing`} userInfo={props.logedInUser.user_role} component={asyncComponent(() => import('./ProjectManagementTool/Project/AdminProjectListing'))} /> */}
          <PayablePartnerRoute
            path={`${props.match.url}invoice-list`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./ClientLogin/PayablePartnerDashboard")
            )}
          />
          <PMTRoute
            path={`${props.match.url}invoice-requests`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/InvoiceRequest/InvoiceRequest")
            )}
          />
          <AllExceptExternalAgentRoute
            path={`${props.match.url}pincode-management`}
            component={asyncComponent(() =>
              import("./PincodeManagement/PincodeManagement")
            )}
          />
          <PMTRoute
            path={`${props.match.url}audit-visits`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/AuditVisits/AuditVisitsList")
            )}
          />
          <PMTRoute
            path={`${props.match.url}escalate-tasks`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/EscalateTasks/index")
            )}
          />
          <PMTRoute
            path={`${props.match.url}kci`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/KciDashboard/Kci")
            )}
          />
          <PMTRoute
            path={`${props.match.url}kci-add-template`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/KciDashboard/KciCreate")
            )}
          />
          <PMTRoute
            path={`${props.match.url}kci-edit-template/:id`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/KciDashboard/KciEdit")
            )}
          />
          <AllExceptExternalAgentRoute
            path={`${props.match.url}interactions`}
            component={asyncComponent(() =>
              import("./Interactions/Interactions")
            )}
          />
          <PMTRouteAdmin
            path={`${props.match.url}analytics-dashboard`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Analytics/AnalyticsDashboard")
            )}
          />
          <PMTRoute
            path={`${props.match.url}surveys`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() => import("./Surveys/Surveys"))}
          />
          <PMTRoute
            path={`${props.match.url}add-survey`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Surveys/SurveyFormBuilder")
            )}
          />
          <PMTRoute
            path={`${props.match.url}edit-survey/:id`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Surveys/SurveyFormBuilder")
            )}
          />
          <OrionRoute
            path={`${props.match.url}rate-cards`}
            component={asyncComponent(() =>
              import("./VendorRateCards/RateCardList")
            )}
          />
          <OrionRoute
            path={`${props.match.url}create-rate-card`}
            component={asyncComponent(() =>
              import("./VendorRateCards/CreateRateCard")
            )}
          />
          <OrionRoute
            path={`${props.match.url}edit-rate-card/:rateId`}
            component={asyncComponent(() =>
              import("./VendorRateCards/CreateRateCard")
            )}
          />
          <VendorRoute
            path={`${props.match.url}rate/:rateId`}
            component={asyncComponent(() =>
              import("./VendorRateCards/RateCards")
            )}
          />
          <OrionRoute
            path={`${props.match.url}vendor-collections`}
            component={asyncComponent(() =>
              import("./VendorSurveys/Collections")
            )}
          />
          <OrionRoute
            path={`${props.match.url}create-collection`}
            component={asyncComponent(() =>
              import("./VendorSurveys/CollectionFormBuilder")
            )}
          />
          <OrionRoute
            path={`${props.match.url}edit-collection/:id`}
            component={asyncComponent(() =>
              import("./VendorSurveys/CollectionFormBuilder")
            )}
          />
          <OrionRoute
            path={`${props.match.url}vendor-data-review`}
            component={asyncComponent(() =>
              import("./VendorDataReview/VendorDataReview")
            )}
          />
          <EngineerRoute
            path={`${props.match.url}account-options`}
            component={asyncComponent(() =>
              import("./EngineerProfile/EngineerProfile")
            )}
          />
          <VendorPlanRoute
            path={`${props.match.url}partner-plans`}
            component={asyncComponent(() => import("./Dashboard/PartnerPlans"))}
          />
          <OrionRoute
            path={`${props.match.url}all-interactions`}
            component={asyncComponent(() =>
              import("./AllPartnerInteractions/AllPartnerInteractions")
            )}
          />
          <OrionRoute
            path={`${props.match.url}pincode-partners`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/AutoAllocate/PincodePartners/PincodePartners"
              )
            )}
          />
          <OrionRoute
            path={`${props.match.url}techlocal-collections`}
            component={asyncComponent(() =>
              import("./TechlocalSummary/Collections")
            )}
          />
          <PMTRoute
            path={`${props.match.url}techlocal-users`}
            component={asyncComponent(() => import("./TechlocalUsers/Users"))}
          />
          <PMTRoute
            path={`${props.match.url}techlocal-user/:uuid`}
            component={asyncComponent(() =>
              import("./TechlocalUsers/UserDetail")
            )}
          />
          <OrionRoute
            path={`${props.match.url}registered-partners`}
            component={asyncComponent(() =>
              import("./Dashboard/RegisteredPartners")
            )}
          />
          <OrionRoute
            path={`${props.match.url}exchange-transactions`}
            component={asyncComponent(() =>
              import("./Dashboard/ExchangeTransactions")
            )}
          />
          <FinanceRoute
            path={`${props.match.url}partner-collections`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/PartnerCollections/PartnerCollections")
            )}
          />
          <FinanceRoute
            path={`${props.match.url}deposits-refunds`}
            userInfo={props.logedInUser.user_role}
            component={asyncComponent(() =>
              import("./Finance/PartnerDepositRefund/PartnerDepositRefund")
            )}
          />
          <OrionRoute
            path={`${props.match.url}additional-profiling`}
            component={asyncComponent(() =>
              import("./AdditionalProfiling/AdditionalProfiling")
            )}
          />
          <OrionRoute
            path={`${props.match.url}create-profiling-form`}
            component={asyncComponent(() =>
              import("./AdditionalProfiling/ProfilingBuilder")
            )}
          />
          <OrionRoute
            path={`${props.match.url}create-profiling-tree-based`}
            component={asyncComponent(() =>
              import("./AdditionalProfiling/ProfilingBuilderTreeBased")
            )}
          />
          <OrionRoute
            path={`${props.match.url}edit-profiling-form/:id`}
            component={asyncComponent(() =>
              import("./AdditionalProfiling/ProfilingBuilderTreeBased")
            )}
          />
          <OrionRoute
            path={`${props.match.url}profiling-questionnaire`}
            component={asyncComponent(() =>
              import("./AdditionalProfiling/UserProfiling")
            )}
          />
          <OrionRoute
            path={`${props.match.url}questionnaire`}
            component={asyncComponent(() =>
              import("./AdditionalProfiling/ConversationalProfiling")
            )}
          />
          <PMTRoute
            path={`${props.match.url}bulk-document-upload-link-generator`}
            component={asyncComponent(() =>
              import(
                "./ProjectManagementTool/Tickets/DynamicLink/BulkDocumentUploadLink"
              )
            )}
          />
          <PMRoute
            path={`${props.match.url}work-order-list`}
            component={asyncComponent(() =>
              import("./ProjectManagementTool/WorkOrders/WorkOrderList")
            )}
          />
        </Switch>
        <PMTClientDashboard
          path={`${props.match.url}client-create-ticket`}
          component={asyncComponent(() =>
            import("./ProjectManagementTool/Tickets/ClientCreateTicket")
          )}
        />
        <PMTClientDashboard
          path={`${props.match.url}client-project-create-edit`}
          component={asyncComponent(() =>
            import("./ProjectManagementTool/Project/ClientProjectCreateEdit")
          )}
        />
        <PMTClientDashboard
          path={`${props.match.url}client-tasks`}
          component={asyncComponent(() =>
            import("./ProjectManagementTool/Tasks/ClientTasks")
          )}
        />
      </div>
    </>
  );
};

export default connect(mapStateToProps)(App);
